// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"_19XUUMvKvabZp8AiyF8pZk","tableContentWrapper":"_12cIqW9RROHBW5CUU9qehn","tableContent":"_3exf8bKclFS9SU34MPmE72","wrapper":"Mem6uHi9OKu1weEsPrV8r"};